import { useEffect } from "react";
import DOMPurify from "dompurify";
import { API } from "../api";

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "";

// Uploaded images are stored with relative "/api/uploads/..." URLs so the site keeps working if the domain changes.
export const toStoredHtml = (html) => (html || "").split(`${API}/uploads/`).join("/api/uploads/");
export const fromStoredHtml = (html) => (html || "").split("/api/uploads/").join(`${API}/uploads/`);

// Resolve upload URLs, then strip anything unsafe before rendering article HTML.
export const cleanHtml = (html) =>
  DOMPurify.sanitize(fromStoredHtml(html), { ADD_ATTR: ["target", "rel"] });

export function useDocumentTitle(title, description) {
  useEffect(() => {
    if (!title) return undefined;
    const prev = document.title;
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    if (description) {
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    return () => {
      document.title = prev;
      if (description && meta && prevDesc != null) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
